import {settings} from './appSettings';

export const CONFIG = {
	EMAIL_API: 'application/email',
	
	EMAIL_SEND_API: 'application/email/send',

	EMAIL_REGEX: settings.email_regex,
	DATE_REGEX: settings.date_regex,
	BIRTHDATE_REGEX: settings.birthdate_regex,
	NAME_REGEX: settings.name_regex,
	MOBILE_REGEX: settings.mobile_regex,
	ADDRESS_REGEX: settings.address_regex,
	OCCUPATION_REGEX: settings.occupation_regex,
	MESSAGE_REGEX: settings.message_regex,
	
	FNAME_LENGTH: settings.fname_max_length,
	LNAME_LENGTH: settings.lname_max_length,
	MOBILE_LENGTH: settings.mobile_max_length,
	EMAIL_LENGTH: settings.email_max_length,
	OCCUPATION_LENGTH: settings.occupation_max_length,
	ADDRESS_LENGTH: settings.address_max_length,
	NAME_LENGTH: settings.name_max_length,
	
	GOOGLE_SITE_KEY: settings.google_site_key,
	GOOGLE_SECRET_KEY: settings.google_secret_key,

	INQUIRY_RECIPIENT: settings.email_to,
	SUPPORT_EMAIL: settings.support_email,

	SMTP_HOST: "smptout.asia.secureserver.net",
	SMTP_PORT: "",
	SMTP_SECURE: false,
	SMTP_REQUIRE: true,
	SMTP_USERNAME: "",
	STMP_PASSWORD: ""
}